import { render } from "./ProductionOrderCard.vue?vue&type=template&id=2abc543e"
import script from "./ProductionOrderCard.vue?vue&type=script&lang=js"
export * from "./ProductionOrderCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__